import clsx from "clsx";
import { Ellipse } from "@/icons";
import { Ellipse2 } from "@/icons";
import { Ellipse3 } from "@/icons";
import { ComponentType } from "react";
import "./CardService.scss";
import { HeadingLevel } from "@/types/headings";

export type CardServiceProps = {
  title: string;
  href?: string;
  titleTag: HeadingLevel;
  asLink?: "a" | ComponentType<any>;
  className?: string;
  iconType?: "icon1" | "icon2" | "icon3";
};

export const CardService = ({
  title,
  href,
  titleTag: TitleTag = "h2",
  asLink = "a",
  className,
  iconType = "icon1",
}: CardServiceProps) => {
  const getIcon = (type: string) => {
    switch (type) {
      case "icon1":
        return <Ellipse />;
      case "icon2":
        return <Ellipse2 />;
      case "icon3":
        return <Ellipse3 />;
      default:
        return null;
    }
  };

  const LinkComponent = asLink;
  return (
    <LinkComponent className={" text-decoration-none"} href={href}>
      <div
        className={clsx(
          className,
          "ui-service-card",
          "bg-primary br-x4 py-x24 pl-x24 w-full shadow ",
        )}
      >
        <TitleTag className="flex-1 h-full base-row align-items-center fs-5 md-fs-4 text-white fw-semibold ">
          {title}
        </TitleTag>
        <div className={clsx("ui-service-card-icon")}>
          <span>{getIcon(iconType)}</span>
        </div>
      </div>
    </LinkComponent>
  );
};
